import AppHypertuneProvider from '../components/HypertuneProvider'
import { useAuth } from '../contexts/Auth'
import { Navigate, Outlet } from 'react-router-dom'

export const LayoutNotLogged: React.FC = () => {
  const { isLogged } = useAuth()

  if (isLogged === true) {
    // Ensure redirection to home page if the user is logged
    return <Navigate to="/" />
  }

  return (
    <AppHypertuneProvider>
      <Outlet />
    </AppHypertuneProvider>
  )
}
